import { zeroValueAmount } from '../components/apple_pay_hook';
import { adyenCheckout } from '../lib/adyen_checkout';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';
import { ADYEN_ENVIRONMENT, ADYEN_CLIENT_KEY } from '@reverbdotcom/env';
import { core_apimessages_AddressEntry } from '../schemas/rql';

export function getApplePayConfiguration(user: IUser, paymentMethodsConfig: string, listingCurrencyCode: string, onShippingContactSelected: any, onAuthorized: any, onError: any) {
  const { locale, countryCode } = { locale: 'en', countryCode: 'US', ...user };
  const fiveDigitLocale = [locale, countryCode].join('_');
  const configuration = {
    paymentMethodsResponse: JSON.parse(paymentMethodsConfig),
    amount: zeroValueAmount(user.currency, listingCurrencyCode),
    clientKey: ADYEN_CLIENT_KEY,
    environment: ADYEN_ENVIRONMENT,
    locale: fiveDigitLocale,
  };

  const applePayProps = {
    totalPriceStatus: 'pending',
    requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
    onError,
    onShippingContactSelected,
    onAuthorized,
  };
  const checkout = adyenCheckout({ configuration });
  return checkout.create('applepay', applePayProps as any);
}

export function paymentContactToAddressParams(shippingContact: ApplePayJS.ApplePayPaymentContact): core_apimessages_AddressEntry {
  return {
    name: [shippingContact.givenName, shippingContact.familyName].join(' '),
    streetAddress: shippingContact.addressLines && shippingContact.addressLines[0],
    extendedAddress: shippingContact.addressLines && shippingContact.addressLines[1],
    locality: shippingContact.locality,
    postalCode: shippingContact.postalCode,
    region: shippingContact.administrativeArea,
    countryCode: shippingContact.countryCode?.toUpperCase(),
    phone: shippingContact.phoneNumber,
  };
}
